import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgFlameDiscount = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 55 58"
    {...props}
  >
    <path
      fill="url(#flame-discount_svg__a) #f93960"
      fillRule="evenodd"
      d="M18.132 2.375s3.53 4.243 11.664 4.84l.002.137C43.718 7.355 55 18.64 55 32.56c0 13.614-10.792 24.707-24.287 25.191v.018C-5.477 59.338-.608 21.562 1.394 17.354c.097 3.22.635 7.172 3.88 8.056C1.911 7.85 11.131 0 11.131 0c.86 2.865 2.48 5.47 4.54 7.794.295.324.59.649.904.963.154.157.31.311.468.463.257-4.148 1.089-6.845 1.089-6.845z"
      clipRule="evenodd"
      opacity={0.9}
    />
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M24.902 26.51a4.21 4.21 0 1 1-8.42 0 4.21 4.21 0 0 1 8.42.001zm-1.81-.056a2.457 2.457 0 1 1-4.913 0 2.457 2.457 0 0 1 4.913 0zm11.635 10.583a4.21 4.21 0 1 1-8.42 0 4.21 4.21 0 0 1 8.42 0zm-1.81-.056a2.457 2.457 0 1 1-4.911-.001 2.457 2.457 0 0 1 4.91.001z"
      clipRule="evenodd"
    />
    <path stroke="#fff" strokeWidth={1.8} d="m17.885 39.335 14.381-14.228" />
    <defs>
      <linearGradient
        id="flame-discount_svg__a"
        x1={40.096}
        x2={58.678}
        y1={-8.92}
        y2={48.373}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF7F08" />
        <stop offset={0.52} stopColor="#FA4668" />
        <stop offset={1} stopColor="#E067AE" />
      </linearGradient>
    </defs>
  </svg>
);
const Memo = memo(SvgFlameDiscount);
export default Memo;
